import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'

import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  swal,
  DropdownTreeSelect,
  Messages,
  Spinner
} from '../../../config/react'
import 'react-multiple-select-dropdown-lite/dist/index.css'
const AddProductSize = () => {
  const urlParams = useParams()
  const queryParams = new URLSearchParams(location.search)
  const country = queryParams.get('country')
  console.log(country)
  const history = useHistory()
  const submitbtnRef = useRef()
  const validator = useRef(new SimpleReactValidator())
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [SelectedCategoryIds, setSelectedCategoryIds] = useState([])

  const [tags, setTags] = useState([])
  const [MaleSize, setMaleSize] = useState([])
  const [FemaleSize, setFemaleSize] = useState([])
  const [UnisexSize, setUnisexSize] = useState([])

  const [inputValue, setInputValue] = useState('')
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [Category, setCategory] = useState([])
  const [CountryList, setCountryList] = useState([])

  const [Inputs, setInputs] = useState({
    id: 0,
    size: '',
    status: 0,
    category_id: '',
    SizeType: '',
    country_id: '',
    CategoryName: '',
    MaleSize: '',
    FemaleSize: '',
    UnisexSize: ''
  })

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.AddProductSize
    GetCountryList()
    if (urlParams.id != null) {
      document.title = Title.EditProductSize
      GetProductSizeDetail()
    } else {
      GetCategories()
    }
  }, [urlParams.id])

  const GetCountryList = (e) => {
    setLoading(true)
    HttpService.getApi(API.GetCountryList).then((response) => {
      setLoading(false)
      setCountryList(response.data.result)
    })
  }

  // const GetParentCatgoryList = (e) => {
  //   setLoading(true)
  //   HttpService.getApi(API.GetParentCategoryList).then((response) => {
  //     setLoading(false)
  //   })
  // }
  const GetCategories = (selectedCategory = []) => {
    HttpService.postApi(API.GetCategory, null).then((response) => {
      setLoading(false)
      if (response.data.result) {
        // filter parent category
        const parentCategories = response.data.result[0].filter(
          (x) => x.parent_id === 1 && x.is_diamond_category === 0
        )
        const categories = []

        parentCategories.map((item) => {
          // filter sub categories by parent
          const filteredSubcategories = response.data.result[0].filter(
            (x) => x.parent_id === item.id
          )
          const subcategories = []
          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id
            )
            const subchildcategories = []
            filteredSubChildCategories.map((childitem) => {
              subchildcategories.push({
                label: childitem.name,
                value: childitem.id,
                checked: selectedCategory.indexOf(childitem.id) >= 0,
                children: []
              })
              return true
            })
            subcategories.push({
              label: subitem.name,
              value: subitem.id,
              checked: selectedCategory.indexOf(subitem.id) >= 0,
              children: subchildcategories
              // disabled: subchildcategories.length > 0
            })
            return true
          })
          categories.push({
            label: item.name,
            value: item.id,
            children: subcategories,
            checked: selectedCategory.indexOf(item.id) >= 0
            // disabled: subcategories.length > 0
          })
          return true
        })
        // if (selectedCategory !== null) {
        //   for (var i = 0; i < categories.length; i++) {
        //     selectedCategory.map((cate) => {
        //       if (parseInt(cate) === categories[i].value) {
        //         categories[i].checked = true
        //       }
        //       return true
        //     })
        //     var children = categories[i].children
        //     if (children.length > 0) {
        //       for (var j = 0; j < children.length; j++) {
        //         selectedCategory.map((cate1) => {
        //           if (parseInt(cate1) === children[j].value) {
        //             categories[i].children[j].checked = true
        //           }
        //           return true
        //         })
        //         var subChildren = children[j].children
        //         if (subChildren.length > 0) {
        //           for (var k = 0; k < subChildren.length; k++) {
        //             selectedCategory.map((cate1) => {
        //               if (parseInt(cate1) === subChildren[k].value) {
        //                 categories[i].children[j].children[k].checked = true
        //               }
        //               return true
        //             })
        //           }
        //         }
        //       }
        //     }
        //   }
        // }

        setCategory(categories)
      }
    })
  }
  const onChangeCategory = (currentNode, selectedNodes) => {
    const array = []
    if (selectedNodes.length > 0) {
      for (let i = 0; i < selectedNodes.length; i++) {
        array.push(selectedNodes[i].value)
      }
    }
    setSelectedCategoryIds(array)
    Category.map((item, index) => {
      if (array.indexOf(item.value) >= 0) {
        Category[index].checked = true
      } else {
        Category[index].checked = false
      }
      item.children.map((subitem, subindex) => {
        if (array.indexOf(subitem.value) >= 0) {
          Category[index].children[subindex].checked = true
        } else {
          Category[index].children[subindex].checked = false
        }
        subitem.children.map((subitem1, subindex1) => {
          if (array.indexOf(subitem1.value) >= 0) {
            Category[index].children[subindex].children[subindex1].checked = true
          } else {
            Category[index].children[subindex].children[subindex1].checked = false
          }
          return true
        })
        return true
      })
      return true
    })
  }

  // const GetCountryList = (e) => {
  //   setLoading(true)
  //   HttpService.getApi(API.GetCountryList).then((response) => {
  //     setLoading(false)
  //     setCountry(response.data.result)
  //   })
  // }

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status') setInputs({ ...Inputs, [prop]: event.target.checked })
    else setInputs({ ...Inputs, [prop]: event.target.value })
    setForceUpdate(!isForceUpdate)
  }

  const GetProductSizeDetail = () => {
    const param = {
      _type: urlParams.id,
      _country: country
    }
    setLoading(true)
    HttpService.postApi(API.GetProductSize, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result[0]
        // console.log(data.filter((x) => x.gender_type === 1)[0].sizes)

        setInputs(response.data.result[0][0])
        setMaleSize(data.filter((x) => x.gender_type === 1)[0].sizes.map((x) => x))
        setFemaleSize(data.filter((x) => x.gender_type === 2)[0].sizes.map((x) => x))
        setUnisexSize(data.filter((x) => x.gender_type === 3)[0].sizes.map((x) => x))
        setTags(response.data.result[0].map((x) => x.size))
        setSelectedCategoryIds(response.data.result[0][0].category_id)
        GetCategories([response.data.result[0][0].category_id])
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  const SubmitForm = (e) => {
    if (submitbtnRef.current) submitbtnRef.current.setAttribute('disabled', 'disabled')

    const param = {
      type: Inputs.SizeType,
      MaleSize: MaleSize,
      FemaleSize: FemaleSize,
      UnisexSize: UnisexSize,
      status: Inputs.status,
      countryId: Inputs.country_id
    }

    setLoading(true)
    HttpService.postApi(API.SetProductSize, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        submitbtnRef.current.removeAttribute('disabled')
        return
      }
      if (urlParams.id == null) toast.success(Messages.RecordAdded)
      else toast.success(Messages.RecordUpdated)
      setForceUpdate(!isForceUpdate)
      history.push('/system/productsize')
    })
  }
  const handleKeyDown = (e, value) => {
    if (e.key === 'Enter') {
      if (value === 'MaleSize') {
        setMaleSize([...MaleSize, Inputs.MaleSize])
        setInputs({ ...Inputs, MaleSize: '' })
      } else if (value === 'FemaleSize') {
        setFemaleSize([...FemaleSize, Inputs.FemaleSize])
        setInputs({ ...Inputs, FemaleSize: '' })
      } else if (value === 'UnisexSize') {
        setUnisexSize([...UnisexSize, Inputs.UnisexSize])
        setInputs({ ...Inputs, UnisexSize: '' })
      }
    }
  }
  const handleRemoveTag = (tag, index, value) => {
    // if (urlParams.id !== null && urlParams.id !== undefined) {
    //   swal(Messages.SwalDeleteProp).then(function (isConfirm) {
    //     if (isConfirm) {
    //       const param = {
    //         id: SelectedCategoryIds,
    //         size: tag,
    //         IsDeleted: true
    //       }
    //       setLoading(true)
    //       HttpService.postApi(API.DeleteProductSize, param).then((response) => {
    //         setLoading(false)
    //         toast.success(Messages.RecordDeleted)
    //         GetProductSizeDetail()
    //         setForceUpdate(!isForceUpdate)
    //       })
    //     }
    //   })
    // }
    setTags(tags.filter((_, i) => i !== index))
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        if (value === 'MaleSize') {
          setMaleSize(MaleSize.filter((_, i) => i !== index))
        } else if (value === 'FemaleSize') {
          setFemaleSize(FemaleSize.filter((_, i) => i !== index))
        } else if (value === 'UnisexSize') {
          setUnisexSize(UnisexSize.filter((_, i) => i !== index))
        }
      }
    })
  }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id == null ? Title.AddProductSize : Title.EditProductSize}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Size Type</label>
                      <input
                        type="text"
                        value={Inputs.SizeType}
                        onChange={handleInputChanges('SizeType')}
                        placeholder="Enter Value"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Select Country</label>
                      <select
                        className="form-control"
                        name="template_id"
                        onChange={handleInputChanges('country_id')}
                        value={Inputs.country_id}
                      >
                        <option value="">Select</option>
                        {CountryList.length > 0 &&
                          CountryList.map((item, index) => (
                            <option
                              key={index}
                              value={item.id}
                            >
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Male Size</label>
                      <div className="tag-input-container">
                        {MaleSize.map((tag, index) => (
                          <div
                            key={index}
                            className="tag"
                          >
                            {tag}
                            <span
                              className="remove-tag"
                              onClick={() => handleRemoveTag(tag, index, 'MaleSize')}
                            >
                              &times;
                            </span>
                          </div>
                        ))}
                        <input
                          type="text"
                          value={Inputs.MaleSize}
                          onChange={handleInputChanges('MaleSize')}
                          onKeyDown={(e) => handleKeyDown(e, 'MaleSize')}
                          placeholder="Enter Value"
                          className="tag-input"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Female Size</label>
                      <div className="tag-input-container">
                        {FemaleSize.map((tag, index) => (
                          <div
                            key={index}
                            className="tag"
                          >
                            {tag}
                            <span
                              className="remove-tag"
                              onClick={() => handleRemoveTag(tag, index, 'FemaleSize')}
                            >
                              &times;
                            </span>
                          </div>
                        ))}
                        <input
                          type="text"
                          value={Inputs.FemaleSize}
                          onChange={handleInputChanges('FemaleSize')}
                          onKeyDown={(e) => handleKeyDown(e, 'FemaleSize')}
                          placeholder="Enter Value"
                          className="tag-input"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Unisex Size</label>
                      <div className="tag-input-container">
                        {UnisexSize.map((tag, index) => (
                          <div
                            key={index}
                            className="tag"
                          >
                            {tag}
                            <span
                              className="remove-tag"
                              onClick={() => handleRemoveTag(tag, index, 'UnisexSize')}
                            >
                              &times;
                            </span>
                          </div>
                        ))}
                        <input
                          type="text"
                          value={Inputs.UnisexSize}
                          onChange={handleInputChanges('UnisexSize')}
                          onKeyDown={(e) => handleKeyDown(e, 'UnisexSize')}
                          placeholder="Enter Value"
                          className="tag-input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 ">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges('status')}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <button
                      ref={submitbtnRef}
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/system/productsize"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 d-none ">
                    <div className="form-group">
                      <label>Product Size</label>
                      <div className="tag-input-container">
                        {tags.map((tag, index) => (
                          <div
                            key={index}
                            className="tag"
                          >
                            {tag}
                            <span
                              className="remove-tag"
                              onClick={() => handleRemoveTag(tag, index)}
                            >
                              &times;
                            </span>
                          </div>
                        ))}
                        <input
                          type="text"
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          onKeyDown={handleKeyDown}
                          placeholder="Enter Value"
                          className="tag-input"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 d-none">
                    <div className="form-group">
                      <label>Category</label>
                      {Category.length > 0 && (
                        <DropdownTreeSelect
                          data={Category}
                          mode="hierarchical"
                          onChange={onChangeCategory}
                          className="bootstrap-demo w-100"
                          disabled
                        />
                      )}
                      {validator.current.message('Category Name', SelectedCategoryIds, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddProductSize
